import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<LanguageProvider><App /></LanguageProvider>)
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
